<template>
    <div>
        <!-- Carousel area -->
        <div ref="scrollBox"
            class="responsiveOreitationHeightAdjust mobile:max-h-[45vh] mobile:mt-4 tablet:mt-4 tablet:max-h-[70vh] desktop:max-h-[50vh] largeDesktop:max-h-[70vh] pr-2  overflow-y-auto customScrollbar">
            <Carousel ref="carouselRef" :mouse-drag="false" :touch-drag="true" :itemsToShow="3"
                :breakpoints="breakpoints" :transition="800">
                <!-- Default slot -->
                <template #default>
                    <slot></slot>
                </template>

                <!-- Addons slot (hidden, just to capture data) -->
                <template #addons="{ currentSlide: cs, slidesCount: sc, goToSlide: gts }">
                    <div style="display: none">
                        {{ captureAddonsData(cs, sc, gts) }}
                    </div>
                </template>
            </Carousel>
        </div>

        <!-- Addons outside -->
        <div v-if="showControls" class="mobile:py-2 tablet:py-3 flex justify-center items-center gap-4">
            <!-- Prev button -->
            <button
                class="group w-10 h-10 rounded-full border-2 border-[#BA90C6] mobile:bg-[#BA90C6] tablet:bg-white hover:bg-[#BA90C6] flex items-center justify-center"
                @click="prevSlide">
                <font-awesome-icon icon="arrow-left" class="w-5 h-5 mobile:text-white tablet:text-[#BA90C6] tablet:group-hover:text-white" />
            </button>

            <!-- Custom pagination -->
            <customSliderPagination :currentSlide="outsideCurrentSlide" :slidesCount="outsideSlidesCount"
                @go-to-slide="outsideGoToSlide" />

            <!-- Next button -->
            <button
                class="group w-10 h-10 rounded-full border-2 border-[#BA90C6] mobile:bg-[#BA90C6] tablet:bg-white hover:bg-[#BA90C6] flex items-center justify-center"
                @click="nextSlide">
                <font-awesome-icon icon="arrow-right" class="w-5 h-5 mobile:text-white tablet:text-[#BA90C6] tablet:group-hover:text-white" />
            </button>
        </div>
    </div>
</template>

<script>
import { Carousel } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import customSliderPagination from "../../components/partialComponent/customSliderPagination.vue";

export default {
    props: ["length"],
    components: { Carousel, customSliderPagination },

    data() {
        return {
            windowWidth: window.innerWidth,
            observer: null,
            outsideCurrentSlide: 0,
            outsideSlidesCount: 0,
            outsideGoToSlide: null,
            defaultBreakpoints: {
                1440: { itemsToShow: 3, wrapAround: false, snapAlign: "start" },
                1366: { itemsToShow: 2, wrapAround: false, snapAlign: "start" },
                1024: { itemsToShow: 2, wrapAround: false, snapAlign: "start" },
                600: { itemsToShow: 1, wrapAround: false, snapAlign: "start" },
                300: { itemsToShow: 1, wrapAround: false, snapAlign: "start" }
            }
        };
    },

    computed: {
        showControls() {
            if (this.windowWidth > 1439) {
                return this.length > 3;
            } else if (this.windowWidth > 1024 && this.windowWidth <= 1439) {
                return this.length > 2;
            } else {
                return this.length > 1;
            }
        },
        breakpoints() {
            return {
                1440: {
                    itemsToShow: Math.min(this.length, 3), // 1->1, 2->2, 3+->3
                    wrapAround: false,
                    snapAlign: "start"
                },
                1366: {
                    itemsToShow: Math.min(this.length, 2), // 1->1, 2->2, 3+->2
                    wrapAround: false,
                    snapAlign: "start"
                },
                1024: {
                    itemsToShow: Math.min(this.length, 2), // 1->1, 2->2, 3+->2
                    wrapAround: false,
                    snapAlign: "start"
                },
                600: {
                    itemsToShow: 1, // hamesha 1
                    wrapAround: false,
                    snapAlign: "start"
                },
                300: {
                    itemsToShow: 1, // hamesha 1
                    wrapAround: false,
                    snapAlign: "start"
                }
            };
        }
    },

    methods: {
        resetScroll() {
            const box = this.$refs.scrollBox;
            if (box && typeof box.scrollTo === 'function') {
                box.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
        },
        captureAddonsData(cs, sc, gts) {
            this.outsideCurrentSlide = cs;
            this.outsideSlidesCount = sc;
            this.outsideGoToSlide = gts;
        },
        prevSlide() {
            this.$refs.carouselRef?.prev();
            setTimeout(() => {
                this.resetScroll();    
            }, 1000);
        },
        nextSlide() {
            this.$refs.carouselRef?.next();
            setTimeout(() => {
                this.resetScroll();
            }, 1000);
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    },

    mounted() {
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener("resize", this.handleResize);

        const wrapper = this.$el.querySelector(".carousel__track");
        if (wrapper) {
            this.observer = new ResizeObserver(() => {
                if (this.$refs.carouselRef?.updateSlideWidth) {
                    this.$refs.carouselRef.updateSlideWidth();
                }
            });
            this.observer.observe(wrapper);
        }

        // Force start from index 0
        this.$nextTick(() => {
            if (this.$refs.carouselRef?.slideTo) {
                this.$refs.carouselRef.slideTo(0);
            }
        });
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
        if (this.observer) this.observer.disconnect();
    }
};
</script>
